import { Link } from "react-router-dom";
import { PawPrint, InstagramLogo, TiktokLogo, YoutubeLogo } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-24 bg-card/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <PawPrint weight="fill" className="text-primary" size={22} />
            <span className="font-modern text-lg font-semibold tracking-tight">MR<span className="text-primary">.</span>WIGGLEZ</span>
          </div>
          <p className="text-muted-foreground max-w-sm text-sm leading-relaxed">
            Pitbull streetwear & innovative dog gear in hot-pink and aqua hypercolor. Oversized hoodies, premium tees, the Mrs. Wigglez line, human + dog matching sets, and reflective night-safe pet gear.
          </p>
          <div className="flex gap-4 mt-6 text-muted-foreground">
            <InstagramLogo size={22} className="hover:text-primary transition-colors cursor-pointer" />
            <TiktokLogo size={22} className="hover:text-primary transition-colors cursor-pointer" />
            <YoutubeLogo size={22} className="hover:text-primary transition-colors cursor-pointer" />
          </div>
        </div>
        <div>
          <p className="overline text-white mb-4">Shop</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/shop" className="hover:text-primary transition-colors">Hoodies & Tees</Link></li>
            <li><Link to="/shop" className="hover:text-primary transition-colors">Mrs. Wigglez</Link></li>
            <li><Link to="/shop" className="hover:text-primary transition-colors">Matching Sets</Link></li>
            <li><Link to="/dog-gear" className="hover:text-secondary transition-colors">Dog Gear</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-white mb-4">Platform</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/collabs" className="hover:text-primary transition-colors">City Collabs</Link></li>
            <li><Link to="/wrap" className="hover:text-primary transition-colors">Neon Wrap</Link></li>
            <li><Link to="/hub" className="hover:text-primary transition-colors">Mr Hub</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Mr. Wigglez. All rights reserved.
      </div>
    </footer>
  );
}
